import { requestTemplate } from 'api';
import { IDocument } from 'interfaces';

// TERMS OF ACCESS
const getTermsOfAccess = (room_id: string) => requestTemplate.get<IDocument[]>(`/documents/terms_of_access/?room_id=${room_id}`);

const uploadTerm = (
  payload: FormData,
) => requestTemplate.post<IDocument>(`/documents/terms_of_access/`, payload, {
   headers: { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data' }
});

const deleteTermOfAccess = (document_id: string, room_id: string) => requestTemplate.delete(`/documents/terms_of_access/?document_id=${document_id}&room_id=${room_id}`);

const getStateOfTerm = (document_id: string, room_id: string) => requestTemplate.get(`/documents/terms_of_access/${document_id}/?room_id=${room_id}`);

const acceptTerm = (
  payload: {document_id: string, room_id: string}
) => requestTemplate.post(`/documents/terms_of_access/accept/?document_id=${payload.document_id}&room_id=${payload.room_id}`);

const rejectTerm = (
  payload: {document_id: string, room_id: string}
) => requestTemplate.post(`/documents/terms_of_access/decline/?document_id=${payload.document_id}&room_id=${payload.room_id}`);

const logExportTermState = (
  p: {room_id: string, entity_id: string, action_type?: string, log_type?: string, }
) => requestTemplate.post(
  `/documents/agreement/log/?room_id=${p.room_id}&entity_id=${p.entity_id}&action_type=${p.action_type}&log_type=${p.log_type}`
);

// TERMS OF RELATED ROOMS
const getChainOfRooms = (
  room_id: string, parent_room_id: string
) => requestTemplate.get(`/access_points/related_chain/?parent_room_id=${parent_room_id}&room_id=${room_id}`);
const getRelatedRooms = (payload: {room_id: string, can_create_access_point?: boolean}) => requestTemplate.get(`/access_points/`, {
  params: payload,
});
const getReferringRooms = (room_id: string) => requestTemplate.get(`/access_points/invoking/?room_id=${room_id}`);
const addRelatedRoom = (payload: FormData) => requestTemplate.post<IDocument>(`/access_points/`, payload, {
  headers: { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data' }
});
const getStateOfRoomTerm = (document_id: string, room_id: string) => requestTemplate.get(`/access_points/${document_id}/`);

const acceptRoomTerm = (
  payload: {access_point_id: string}
) => requestTemplate.post(`/access_points/accept/?access_point_id=${payload.access_point_id}`);

const rejectRoomTerm = (
  payload: {access_point_id: string}
) => requestTemplate.post(`/access_points/decline/?access_point_id=${payload.access_point_id}`);

const deleteRoomTermOfAccess = (access_point_id: string) => requestTemplate.delete(`/access_points/?access_point_id=${access_point_id}`);

const terms = {
  getTermsOfAccess,
  uploadTerm,
  deleteTermOfAccess,
  getStateOfTerm,
  acceptTerm,
  rejectTerm,
  logExportTermState,

  getChainOfRooms,
  getRelatedRooms,
  getReferringRooms,
  addRelatedRoom,
  getStateOfRoomTerm,
  acceptRoomTerm,
  rejectRoomTerm,
  deleteRoomTermOfAccess,
};

export default terms;
